import { render, staticRenderFns } from "./EnvioInventarioFormComponent.vue?vue&type=template&id=5d873db0&"
import script from "./EnvioInventarioFormComponent.vue?vue&type=script&lang=js&"
export * from "./EnvioInventarioFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports